<script setup>
import Layout from "@/layouts/main.vue";
import _, { isEmpty } from 'lodash';
import PageHeader from "@/components/page-header";
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import vSelect from 'vue-select'
import axios from 'axios';
import { authHeader } from "../../helpers/authservice/auth-header";
import 'vue-select/dist/vue-select.css';
import Swal from 'sweetalert2';
import moment from 'moment';

  const store = useStore();
  const loading = computed(() => store.state.globals.loading);
  const title = ref("User Password Generator");
  const items = ref([
    {
      text: "Home",
      href: "/"
    },
    {
      text: "User Management",
    },
    {
      text: "User Password Generator",
      active: true,
    }
]);

onMounted(() => {
    watchEffect(()=>{
        if (search.value) {
            setSelected();
        }
    });
})

const search = ref('');

const result = ref(null);

const users = ref([]);

const searchQuery =  _.debounce( async  (loading = false, search = '') => {
  const { data } = await axios.get(`/users?search=${encodeURIComponent(search)}`, {
      headers: authHeader()
  });

  users.value = data.data;

  if (loading) {
    loading(false)
  }
}, 500)

const onSearch = (search, loading) => {
  if(search.length) {
    loading(true);
    searchQuery(loading, search);
  }
}

const setSelected = async () => {
    result.value = await users.value.find(user => user.id === search.value);
}

const generateTemporaryPassword = () => {
    if (!search.value && !result.value && (!result.value.email || !result.value.username)) return;

    try {
        Swal.fire({
            title: "Generate Temporary Password",
            text: "Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes",
        }).then(async (res) => {
            if (res.value) {
                let userInfo = null;
                
                if (!isEmpty(result.value.username)) {
                    userInfo = { username: result.value.username };
                }

                if (!isEmpty(result.value.email)) {
                    userInfo = { email: result.value.email };
                }

                const response = await axios.post(`/generate_temporary_password`, userInfo, {
                    headers: authHeader()
                })

                Swal.fire(
                    "Generated!", 
                    `Temporary password generated to ${result.value.username ? result.value.username : result.value.email}'s account. Here's the temporary password: ${response.data.password}`, 
                    "success"
                );

                search.value = '';
            }
        });
    } catch (err) {
        console.log(err);
    }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
      <div class="d-flex mb-4 justify-content-between">
        <div>
          <h1 class="fs-4 text">User Password Generator</h1>
          <small>This page is a tool for resetting or activating QPAX user accounts.</small>
        </div>
      </div>

      <div class="row">
          <div class="col md-12 col-lg-6">
            <b-overlay :show="loading">
                <div class="card">
                    <div class="card-body p-4">
                        <div class="row mb-5">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="search">Search User Account</label>
                                    <v-select @change="setSelected" placeholder="Select Users" :get-option-label="(option) => option.name" :reduce="users => users.id" :filterable="false" :options="users" @search="onSearch" v-model="search">
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <h5 class="mb-2">User Information</h5>
                            <div class="row">
                                <label for="username" class="col-sm-4 col-form-label-sm">Username</label>
                                <div class="col-sm-8">
                                    {{ result && result.username ? result.username : 'n/a' }}
                                </div>
                            </div>
                            <div class="row">
                                <label for="email" class="col-sm-4 col-form-label-sm">Email</label>
                                <div class="col-sm-8">
                                    {{ result && result.email ? result.email : 'n/a' }}
                                </div>
                            </div>
                            <div class="row mb-4">
                                <label for="last_login_at" class="col-sm-4 col-form-label-sm">Last Login</label>
                                <div class="col-sm-8">
                                    {{ result && result.last_login_at ? moment(result.last_login_at).format('YYYY-MM-DD hh:mm A'): 'n/a' }}
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button @click.prevent="generateTemporaryPassword" :disabled="!result" class="btn btn-primary form-control">
                                    <i class="mdi mdi-lock-reset fs-3 text align-middle mr-2"></i>
                                    Generate Temporary Password</button>
                            </div>
                        </div>
                    </div>
                </div>
             </b-overlay>
          </div>
      </div>
    
  </Layout>
   <!-- Varying modal content -->
</template>

<style>
    :root {
    --vs-font-size: 0.8rem;
    }
</style>